import styles from "../style";
import data from "../constants/sliderservices";
import { IoCash } from "react-icons/io5";
import { Reveal } from "./reveal";

const Thesis = () => {
  return (
    <div className="py-20 w-full max-w-[1200px] mx-auto px-4 sm:px-6 md:px-8 lg:px-10">
        <div className="flex flex-col gap-12 md:gap-16 lg:gap-20 w-full">
          {data.map((card, index) => (
            <div key={index} className="relative w-full">
              {/* Number as background element */}
              <span className="absolute md:left-10 left-2 top-24 md:top-1/2 md:-translate-y-1/2 text-[80px] md:text-[100px] font-bold text-fourth select-none pointer-events-none z-0 leading-none">
                {card.number}
              </span>
              
              {/* Content container with proper spacing for text visibility */}
              <div className="relative z-10 ml-12 sm:ml-20 md:ml-24 lg:ml-32 pb-6 border-b border-1 border-second">
                <div className="flex flex-col gap-3">
                  <p className="xs:text-sm text-ss mt-5 break-words text-tertiary/80">
                    AfriNext
                  </p>
                  
                  <div className="flex flex-row gap-2 items-start">
                    <IoCash color="#7c7401" size={18} className="flex-shrink-0 mt-1"/>
                    <Reveal>
                      <h2 className="xs:text-mm text-sm font-semibold break-words hyphens-auto">
                        {card.name}
                      </h2>
                    </Reveal>
                  </div>
                  
                  <span className="border-b border-2 border-second w-[80px] md:w-[100px]"></span>
                  
                  <Reveal>
                    <p className="xs:text-sm text-ss break-words hyphens-auto leading-relaxed text-tertiary/70 pr-2 sm:pr-6 md:pr-10 pb-4">
                      {card.detail}
                    </p>
                  </Reveal>
                </div>
              </div>                
            </div>
          ))}      
        </div>
      </div> 
  );
};

export default Thesis;